import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { Dialog, DialogContent } from '@/components/ui/dialog'

import { TourModalActions } from './tour-modal-actions'
import { TourModalCarousel } from './tour-modal-carousel'
import { TourModalContent } from './tour-modal-content'

type TourModalProps = {
  open: boolean
  setOpen: (value: boolean) => void
  onStartTour: () => void
  onSkipTour: () => void
  updateTourHistory: (value: boolean) => void
} & {
  readonly children?: never
}

export const TourModal: React.FC<TourModalProps> = ({
  open,
  setOpen,
  onStartTour,
  onSkipTour,
  updateTourHistory,
}) => {
  const { t } = useTranslation()
  const handleStartTour = useCallback(() => {
    onStartTour()
  }, [onStartTour])

  const handleSkip = useCallback(() => {
    onSkipTour()
  }, [onSkipTour])

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-5xl" closeButton>
        <div className="grid md:grid-cols-[40%_1fr] gap-8">
          <TourModalContent
            onDontShowAgain={(value: boolean) => updateTourHistory(value)}
          />
          <div className="space-y-8 p-6 overflow-scroll max-h-[700px]">
            <div>
              <h2 className="text-2xl font-semibold mb-4">
                {t('tour-benefits-title')}
              </h2>
              <p className="text-gray-600 mb-4">
                {t('tour-benefits-description')}
              </p>
              <ul
                className="space-y-2 text-gray-600"
                role="list"
                aria-label={t('tour-benefits-title')}
              >
                <li>• {t('tour-benefits-item-1')}</li>
                <li>• {t('tour-benefits-item-2')}</li>
                <li>• {t('tour-benefits-item-3')}</li>
              </ul>
            </div>
            <TourModalCarousel />
            <TourModalActions onStart={handleStartTour} onSkip={handleSkip} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
